module.exports = __webpack_public_path__ + "img/foca-no-enem.b95de715.jpg";